import { dateRangeStyles } from "@insite/content-library/Widgets/OrderHistory/OrderHistorySearchFieldDateRange";
import { css } from "styled-components";

dateRangeStyles.datePickersWrapper = {
	css: css`
		justify-content: space-between;
		display: flex;
		> div:first-of-type {
			width: 100%;
		}

		> div:nth-of-type(2) {
			width: 100%;
		}
	`
}